import React from "react";
import { Button } from "@/components/ui/button";
import { ScanLine, MessageCircle } from "lucide-react";
import { waLink } from "@/constants/site";

export default function SkinAnalysis() {
  return (
    <section data-testid="skin-analysis-section" className="iona-section bg-white">
      <div className="iona-container">
        <div className="relative rounded-[2rem] bg-[#F4F1F9] overflow-hidden">
          <div className="grid lg:grid-cols-12 gap-0 items-center">
            <div className="lg:col-span-7 p-10 md:p-16 lg:p-20">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-[#5E2A84] text-xs uppercase tracking-[0.25em] mb-6 border border-[#E8E2F0]">
                <ScanLine className="w-3.5 h-3.5" />
                3D Cilt Analizi
              </div>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight mb-6">
                3D Cilt Analizi ile <br className="hidden md:block" />
                <span className="italic text-[#5E2A84]">cildinizi tanıyın</span>
              </h2>
              <p className="text-base text-[#4A4A4A] leading-relaxed mb-10 max-w-xl">
                Cilt tipinizi, nem dengenizi, leke görünümünü ve ihtiyaçlarınızı
                analiz ederek size özel bakım protokolü oluşturuyoruz.
              </p>

              <a
                href={waLink("Merhaba, 3D Cilt Analizi için randevu almak istiyorum.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="skin-analysis-cta"
              >
                <Button className="h-13 px-7 py-3 rounded-full bg-[#5E2A84] hover:bg-[#4a2168] text-white iona-soft-shadow">
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Cilt Analizi İçin Randevu Al
                </Button>
              </a>
            </div>

            <div className="lg:col-span-5 relative h-[300px] lg:h-[500px]">
              <img
                src="https://images.pexels.com/photos/7670737/pexels-photo-7670737.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
                alt="3D Cilt Analizi"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#F4F1F9] via-transparent to-transparent lg:bg-gradient-to-l" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
